<div class="container" gallerize>
    <img *ngFor="let image of images"
         [src]="image.thumb"
         [attr.imageSrc]="image.src"
         [attr.thumbSrc]="image.thumb"/>
  </div>
